import type { Announcement } from './types';

/**
 * Sélectionne l'unique annonce à afficher, ou null.
 * Invariants : (1) jamais une annonce vue ; (2) jamais antérieure à
 * l'arrivée du membre (pas de backlog pour un onboarding tardif) ;
 * (3) au plus UNE (la plus récente éligible). `catalog` est supposé
 * trié récent→ancien. `joinedAt` : ISO, supposé normalisé UTC (`...Z` —
 * cas des timestamptz Postgres sérialisés). slice(0,10) = jour calendaire.
 */
export function selectLatestUnseen(
  catalog: Announcement[],
  seen: string[],
  joinedAt: string,
): Announcement | null {
  const seenSet = new Set(seen);
  // P1-1 : granularité jour calendaire UTC assumée. joinedAt = timestamptz
  // ISO ('2026-05-15T..Z') → slice(0,10) = 'YYYY-MM-DD'. Comparaison
  // lexicographique sûre car les deux côtés sont en 'YYYY-MM-DD'.
  const joinedDay = joinedAt.slice(0, 10);
  for (const a of catalog) {
    if (seenSet.has(a.id)) continue;
    if (a.date < joinedDay) continue;
    return a;
  }
  return null;
}
